import { getLocalStorageItem } from "./Localstorage/localStorageUtils";

const getUserData = () => {
  try {
    const userDataRaw =
      getLocalStorageItem("userData");

    if (!userDataRaw) return null;

    if (typeof userDataRaw === "string") {
      try {
        return JSON.parse(userDataRaw);
      } catch {
        return null;
      }
    }

    return userDataRaw;
  } catch (error) {
    console.error(
      "Error parsing user data:",
      error
    );
    return null;
  }
};


const getCompanySubscription = () => {
  try {
    const raw =
      getLocalStorageItem(
        "companySubscription"
      );

    if (!raw) return [];

    let parsed;

    if (typeof raw === "string") {
      try {
        parsed = JSON.parse(raw);
      } catch {
        return [];
      }
    } else {
      parsed = raw;
    }

    return Array.isArray(parsed)
      ? parsed
      : [parsed];

  } catch (error) {
    console.error(
      "Error parsing company subscription:",
      error
    );
    return [];
  }
};


const checkAdminPermission = (
  parentData
) => {
  try {

    const subscriptions =
      getCompanySubscription();

    // merge permissions from all subscriptions
    const permissions =
      subscriptions.flatMap(
        sub =>
          sub?.permissions ||
          sub?.subscription
            ?.permissions ||
          []
      );

    // dashboard always allowed
    if (
      parentData ===
      "dashboard/default"
    ) {
      return true;
    }

    // FULL ACCESS
    if (
      permissions.includes("*")
    ) {
      return true;
    }

    // backward compatibility
    if (
      !permissions ||
      permissions.length === 0
    ) {
      return true;
    }

    const currentPath =
      window.location.pathname
        .replace(/^\//, "")
        .split("/")[0];

    const hasPermission =
      permissions.some(p => {

        if (!p) return false;

        const pPath =
          p.split("/")[0];

        return (
          (currentPath &&
            pPath === currentPath) ||

          (parentData &&
            p === parentData)
        );

      });

    if (
      !hasPermission &&
      (
        currentPath === "app" ||
        currentPath === "kanban" ||
        !currentPath
      )
    ) {
      return true;
    }

    return hasPermission;

  } catch (error) {
    console.error(
      "Error in checkAdminPermission:",
      error
    );

    return true;
  }
};



export const PrivilegesViewChecker = (
  parentData
) => {
  try {

    const userData =
      getUserData();

    if (!userData)
      return false;

    const role =
      userData?.role?.toLowerCase();

    if (role === "admin") {
      return checkAdminPermission(
        parentData
      );
    }

    if (role === "user") {

      const Group =
        userData?.Group;

      const privilege =
        Group?.privileges?.[
        parentData
        ];

      return (
        privilege ===
        "Can view" ||

        privilege ===
        "Can create"
      );
    }

  } catch (error) {

    console.error(
      "Error in PrivilegesViewChecker:",
      error
    );

  }

  return false;
};



export const PrivilegesChecker = (
  parentData
) => {

  try {

    const userData =
      getUserData();

    if (!userData)
      return false;

    const role =
      userData?.role?.toLowerCase();

    if (role === "admin") {
      return checkAdminPermission(
        parentData
      );
    }

    if (role === "user") {

      const Group =
        userData?.Group;

      const privilege =
        Group?.privileges?.[
        parentData
        ];

      return (
        privilege ===
        "Can create"
      );

    }

  } catch (error) {

    console.error(
      "Error in PrivilegesChecker:",
      error
    );

  }

  return false;
};